import moment from 'moment'

const FORMAT = 'DD/MM/YYYY'

export function formatDateStringDDMMYYYY(dateString: string) {
  if (!dateString) {
    return ''
  }
  return moment(dateString).format(FORMAT)
}